export default __webpack_public_path__ + "roboto-v27-latin-italic.5b35ce29664d4b37d611ba9081c4e96f.svg";